<template>
  <div id="addRole">
    <div class="title">基本信息</div>
    <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="100">
      <FormItem label="名称" prop="role_name">
        <Input v-model="formValidate.role_name" placeholder="请输入昵称，最多不超多10个字" :maxlength="10" style="width: 400px;" clearable></Input>
        <span>{{roleLength}}/10</span>
      </FormItem>
      <FormItem label="描述">
        <Input
          v-model="formValidate.description"
          type="textarea"
          :maxlength="30"
          :autosize="{minRows: 2,maxRows: 10}"
          placeholder="请输入角色描述，最多不超过30字"
          style="width: 400px;"
          clearable
        ></Input>
        <span>{{descLength}}/30</span>
      </FormItem>
      <div class="title">权限设置</div>
      <!-- <FormItem> -->
      <div style="padding：15px;margin-left:60px">
        <Tree
          ref="tree"
          :data="list"
          show-checkbox
          multiple
          :check-directly="true"
          @on-check-change="checkChange"
        ></Tree>
      </div>
      <!-- </FormItem> -->
      <Divider />
      <FormItem style="text-align:center">
        <Button size="large" :to="{name: 'SettingRole'}">返回</Button>
        <Button
          size="large"
          style="margin: 0 15px;"
          type="primary"
          @click="submits('formValidate')"
        >保存并返回</Button>
      </FormItem>
    </Form>
  </div>
</template>

<script>
export default {
  name: "addRole",
  data() {
    return {
      id: this.$route.query.id || "",
      formValidate: {
        role_name: "",
        description: ""
      },
      roleLength: 0,
      descLength: 0,
      ruleValidate: {
        role_name: [
          { required: true, message: "角色名不能为空！", trigger: "blur" }
        ]
      },
      list: [],
      render1: (h, { data }) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              fontSize: "14px"
            }
          },
          [
            h("span", [
              h("Icon", {
                props: {
                  type: "ios-keypad-outline"
                },
                style: {
                  marginRight: "8px"
                }
              }),
              h("span", data.title)
            ])
          ]
        );
      },
      render2: (h, { data }) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              fontSize: "14px"
            }
          },
          [h("span", data.title)]
        );
      },
      check: [],
      type: this.$route.query.type
    };
  },
  created() {
    this.getMenu();
    this.getData();
  },
  mounted() {},
  watch: {
    "formValidate.role_name": {
      handler: function() {
        this.roleLength = this.formValidate.role_name.length;
      },
      deep: true
    },
    "formValidate.description": {
      handler: function() {
        this.descLength = this.formValidate.description.length;
      },
      deep: true
    }
  },
  methods: {
    getMenu() {
      //  0 平台 1分校
      let params = {};
      if (this.id) {
        params.id = this.id;
      }
      this.$http.get("/api/roleInfo", params).then(res => {
        if (this.id == "") {
          this.list = res.rows.map(org => this.mapTree(org));
        } else {
          this.list = res.rows;
          this.mapOrg(this.list);
          this.$forceUpdate();
        }
        // 帐号管理必选
        function cascadeSet(obj, checkID) {
          if (obj.id == checkID) {
            obj.disabled = true;
            obj.checked = true;
            return true;
          }
          obj.children && obj.children.forEach(i => {
            cascadeSet(i, checkID);
          })
        }
        function cascadeExpand(obj, checkID) {
          if (obj.id == checkID) {
            obj.disabled = true;
            obj.expand = true;
            return true;
          }
          obj.children && obj.children.forEach(i => {
            cascadeExpand(i, checkID);
          })
        }
        this.list.forEach(i => {
          cascadeSet(i, 1811);
          cascadeExpand(i, 181);
        })
        this.$nextTick(() => {
           this.checkChange();
        })
      });
    },
    getData() {
      if (this.id != "") {
        this.$http.get(`/api/role/${this.id}`).then(res => {
          this.formValidate = {
            role_name: res.role_name,
            description: res.description
          };
          this.check = res.menu_ids;
        });
      }
    },
    mapOrg(data) {
      for (var i in data) {
        this.$set(data[i], "selected", data[i].is_select == 1 ? true : false);
        if (data[i].menu_grade == 3) {
          delete data[i].children;
        }
        if (data[i].hasOwnProperty("children")) {
          if (data[i].children[0].menu_type == 2) {
            this.$set(
              data[i],
              "checked",
              data[i].is_select == 1 ? true : false
            );
          }
        } else {
          if (data[i].menu_type == 1) {
            this.$set(
              data[i],
              "checked",
              data[i].is_select == 1 ? true : false
            );
          }
        }
        this.$set(
          data[i],
          "render",
          data[i].menu_type == 1 ? this.render1 : this.render2
        );
        if (data[i].hasOwnProperty("children")) {
          this.mapOrg(data[i].children);
        }
      }
    },
    mapTree(org) {
      const haveChildren =
        Array.isArray(org.children) && org.children.length > 0;
      return {
        //分别将我们查询出来的值做出改变他的key
        id: org.id,
        parent_id: org.parent_id,
        title: org.title,
        menu_url: org.menu_url,
        is_select: org.is_select,
        menu_type: org.menu_type,
        // children: org.menu_url == "" ? org.children : [],
        selected: org.is_select == 1 ? true : false,
        render: org.menu_type == 1 ? this.render1 : this.render2,
        data: { ...org },
        //判断它是否存在子集，若果存在就进行再次进行遍历操作，知道不存在子集便对其他的元素进行操作
        children: haveChildren ? org.children.map(i => this.mapTree(i)) : []
      };
    },
    checkChange() {
      let va = this.$refs["tree"].getCheckedAndIndeterminateNodes();
      this.check = [];
      va.forEach(i => {
        if (i.checked || i.indeterminate) {
          this.check.push(i.id);
        }
      });
    },
    submits(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          if (this.check.length > 0) {
            let ids = '';
            if(typeof this.check == 'string'){
              ids =  this.check
            }else{
               ids = "/" + this.check.join("/") + "/";
            }
            if (this.id == "") {
              let obj = {
                role_name: this.formValidate.role_name,
                description: this.formValidate.description,
                menu_ids: ids
              };
              this.$http.post("/api/role", obj).then(() => {
                this.getMenu();
                this.check = [];
                this.formValidate = {
                  role_name: "",
                  description: ""
                };
                this.$router.push({ name: "SettingRole" });
              });
            } else {
              let obj = {
                role_name: this.formValidate.role_name,
                description: this.formValidate.description,
                menu_ids: ids,
                id: this.id
              };
              this.$http.put(`/api/role/${this.id}`, obj).then(() => {
                this.$router.push({ name: "SettingRole" });
              });
            }
          } else {
            this.$Message.error("请选择菜单权限");
          }
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
#addRole {
  padding: 15px;
  background: #fff;
}
.title {
  position: relative;
  margin-bottom: 10px;
  padding: 5px 15px;
  font-size: 16px;
}
.title::before {
  display: block;
  position: absolute;
  left: 0;
  top: 7px;
  content: "";
  height: 20px;
  background-color: #2d8cf0;
  width: 4px;
}
// ::-webkit-scrollbar {
//   // width: 2px;
// }
</style>